import { render, staticRenderFns } from "./myBuyersBuyerHistory.vue?vue&type=template&id=9f78a724&scoped=true&lang=html&"
import script from "./myBuyersBuyerHistory.vue?vue&type=script&lang=js&"
export * from "./myBuyersBuyerHistory.vue?vue&type=script&lang=js&"
import style0 from "./myBuyersBuyerHistory.vue?vue&type=style&index=0&id=9f78a724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f78a724",
  null
  
)

export default component.exports